export default __webpack_public_path__ + "endpoints_health_endpoint_formula.png";